import { defineStore } from 'pinia';

type FeatureState = Record<string, boolean>;

export const useFeatureStore = defineStore('features', {
  state: (): FeatureState => ({
    insights: false,
  }),

  actions: {
    setFeature(name: string, value: boolean) {
      if (
        Object.prototype.hasOwnProperty.call(this.$state, name) &&
        this.$state[name] !== value
      ) {
        this.$state[name] = value;
      }
    },
  },
});
